/**
 * RFQS STORE
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import { getRfqs, getRfq, printRfq, createRfqs, updateRfqs, deleteRfqs, createQuoteFromRfq, createPoFromRFQ } from "Modules/supply_chain/rfqs/config/api.rfqs";

const state = {
    page: {},
    form: {},
    rfqs: [],
    selectedRfq: {
        rfq_id: null,
        company_id: "",
        rfq_date: "",
        reference_number: "",
        status_id: "",
        billing_address_id: "",
        shipping_address_id: "",
        comments: "",
        rfq_details: [],
    },
    rfqs_filter: {
        search: "",
        status_id: "",
        page_size: 2,
        page_num: 1,
    },
    rules_rfqs: {
        rfq_id: {
            name: "rfq_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        company_id: {
            name: "company_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        rfq_date: {
            name: "rfq_date",
            rules: "trim|required",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        reference_number: {
            name: "reference_number",
            rules: "trim|max_length[50]",
            max_len: "50",
            min_len: "",
            default_value: "",
        },
        currency_id: {
            name: "currency_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        exchange_rate: {
            name: "exchange_rate",
            rules: "trim|max_length[19]|decimal|required",
            max_len: "19",
            min_len: "",
            default_value: "",
        },
        status_id: {
            name: "status_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "16",
        },
        billing_address_id: {
            name: "billing_address_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        bill_location_label: {
            name: "bill_location_label",
            rules: "trim|max_length[65]",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
        bill_address1: {
            name: "bill_address1",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        bill_address2: {
            name: "bill_address2",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        bill_city: {
            name: "bill_city",
            rules: "trim|max_length[100]",
            max_len: "100",
            min_len: "",
            default_value: "",
        },
        bill_state: {
            name: "bill_state",
            rules: "trim|max_length[65]",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
        bill_zip_code: {
            name: "bill_zip_code",
            rules: "trim|max_length[5]",
            max_len: "5",
            min_len: "",
            default_value: "",
        },
        bill_zip_code_ext: {
            name: "bill_zip_code_ext",
            rules: "trim|max_length[4]",
            max_len: "4",
            min_len: "",
            default_value: "",
        },
        bill_country_iso_3: {
            name: "bill_country_iso_3",
            rules: "trim|max_length[3]",
            max_len: "3",
            min_len: "",
            default_value: "",
        },
        shipping_address_id: {
            name: "shipping_address_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        ship_location_label: {
            name: "ship_location_label",
            rules: "trim|max_length[65]",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
        ship_address1: {
            name: "ship_address1",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        ship_address2: {
            name: "ship_address2",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        ship_city: {
            name: "ship_city",
            rules: "trim|max_length[100]",
            max_len: "100",
            min_len: "",
            default_value: "",
        },
        ship_state: {
            name: "ship_state",
            rules: "trim|max_length[65]",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
        ship_zip_code: {
            name: "ship_zip_code",
            rules: "trim|max_length[5]",
            max_len: "5",
            min_len: "",
            default_value: "",
        },
        ship_zip_code_ext: {
            name: "ship_zip_code_ext",
            rules: "trim|max_length[4]",
            max_len: "4",
            min_len: "",
            default_value: "",
        },
        ship_country_iso_3: {
            name: "ship_country_iso_3",
            rules: "trim|max_length[3]",
            max_len: "3",
            min_len: "",
            default_value: "",
        },
        shipping_carrier_id: {
            name: "shipping_carrier_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        freight_term_id: {
            name: "freight_term_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        comments: {
            name: "comments",
            rules: "trim",
            max_len: "65535",
            min_len: "",
            default_value: "",
        },
        vendor_id: {
            name: "vendor_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        department_id: {
            name: "department_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        project_id: {
            name: "project_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        required_by_date: {
            name: "required_by_date",
            rules: "trim",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        expiration_date: {
            name: "expiration_date",
            rules: "trim",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        rfq_details: {
            map_id: {
                name: "map_id",
                rules: "trim|max_length[15]|integer|required",
                max_len: "15",
                min_len: "",
                default_value: "",
            },
            part_id: {
                name: "part_id",
                rules: "trim|max_length[15]|integer|required",
                max_len: "15",
                min_len: "",
                default_value: "",
            },
            quantity: {
                name: "quantity",
                rules: "trim|max_length[11]|integer|required",
                max_len: "11",
                min_len: "",
                default_value: "",
            },
            cost_price: {
                name: "cost_price",
                rules: "trim|max_length[19]|decimal",
                max_len: "19",
                min_len: "",
                default_value: "",
            },
            sales_unit: {
                name: "sales_unit",
                rules: "trim|max_length[15]|integer|required",
                max_len: "15",
                min_len: "",
                default_value: "",
            },
            lead_time: {
                name: "lead_time",
                rules: "trim|max_length[3]|integer",
                max_len: "3",
                min_len: "",
                default_value: "",
            },
            line_description: {
                name: "line_description",
                rules: "trim|max_length[255]",
                max_len: "255",
                min_len: "",
                default_value: "",
            },
        },
    },
};

// getters
const getters = {
    rfqs: (state) => {
        return state.rfqs;
    },
};

// actions
const actions = {
    async fetchRfqs({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            body = payload.body ? payload.body : "";

            const response = await getRfqs({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("setPageRfqs", response.data.page);
                }

                commit("setRfqs", response.data.rfqs);

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async fetchRfq({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getRfq(payload.id);

            if (typeof response !== "undefined" && response.data) {
                commit("setSelectedRfq", response.data.rfq);
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async convertRfqToQuote({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            let rfq_id = body["rfq_id"];
            delete body["rfq_id"];
            response = await createQuoteFromRfq({ body: body, headers: config.headers }, rfq_id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async convertRFQToPurchaseOrder({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            let rfq_id = body["rfq_id"];
            delete body["rfq_id"];
            response = await createPoFromRFQ({ body: body, headers: config.headers }, rfq_id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async printRfq({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printRfq(payload.id, payload.view_as);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
    async saveRfq({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["rfq_id"] === "undefined" || body["rfq_id"] == null || body["rfq_id"] == "") {
                delete body["rfq_id"];
                response = await createRfqs({ body: body, headers: config.headers });
            } else {
                let rfq_id = body["rfq_id"];
                delete body["rfq_id"];
                response = await updateRfqs({ body: body, headers: config.headers }, rfq_id);
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async deleteRfq({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deleteRfqs(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
};

// mutations
const mutations = {
    setPageRfqs(state, page) {
        state.page = page;
    },
    setRfqs(state, rfqs) {
        state.rfqs = rfqs;
    },
    setSelectedRfq(state, rfq) {
        state.selectedRfq = rfq;
    },
    resetSelectedRfq(state) {
        for (const key in state.selectedRfq) {
            if (key in state.rules_rfqs) {
                state.selectedRfq[key] = state.rules_rfqs[key].default_value == "null" ? null : state.rules_rfqs[key].default_value;
            }
        }
    },
    rsetRfqs(state) {
        state.page = {};
        state.rfqs = [];
        state.selectedRfq = {
            rfq_id: null,
            company_id: "",
            rfq_date: "",
            reference_number: "",
            status_id: "",
            billing_address_id: "",
            shipping_address_id: "",
            comments: "",
            rfq_details: [],
        };
        state.rfqs_filter = {
            search: "",
            status_id: "",
            page_size: 2,
            page_num: 1,
        };
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
